'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('ProjectNewCtrl', ProjectNewCtrl);

  ProjectNewCtrl.$inject = ['$scope', 'Auth', 'Project', 'users', 'pveTemplates', 'buildingTemplates', '$mdStepper',
    '$mdComponentRegistry', 'buildingAddDataService', 'errorMessageService', 'Constants', 'Labels',
    '$state', 'ProjectDataservice', 'sgAutocompleteHelpers', 'userManagedProjects', 'Help'];

  function ProjectNewCtrl ($scope, Auth, ProjectAPI, users, pveTemplates, buildingTemplates, $mdStepper,
    $mdComponentRegistry, buildingAddData, errorMessageService, Constants, Labels,
    $state, ProjectDataservice, sgAutocompleteHelpers, userManagedProjects, Help) {

    let stepper;
    // https://github.com/eberlitz/material-steppers/issues/19
    $mdComponentRegistry.when('sg-project-new').then(function () {
      stepper = $mdStepper('sg-project-new');
    });

    // labels is lowercase because of sending it to a directive
    $scope.labels = Labels;
    $scope.qualityLevels = Constants.getList('QUALITY_LEVELS');
    $scope.model = {};
    $scope.building = {};

    $scope.buildingForm = {ref: {}};

    $scope.next = function () {
      stepper.next();
    };

    $scope.prev = function () {
      stepper.back();
    };

    $scope.users = users;

    function getProjectBody (startingPoint) {
      const project = angular.copy($scope.project);

      if (startingPoint === 'copy') {
        delete project.sourceProject;
        project.startSituation = 'copy';
      } else {
        project.qualityLevel = project.qualityLevel.value;
        project.templateId = project.pveTemplate._id;
        project.startSituation = 'empty';
      }

      project.users = project.users.map(function (user) {
        user._id = user.userId._id;
        delete user.userId;
        return user;
      });

      return project;
    }

    $scope.createProjectAndBuilding = function (index, shouldAddBuilding) {

      if (index === 0) {
        $scope.prev();
        return;
      }

      ProjectAPI.addProject({project: getProjectBody($scope.model.startingPoint)}).$promise
        .then((createdProject) => {

          if (shouldAddBuilding) {
            return addBuilding(createdProject);
          }

          return Promise.resolve(createdProject);
        })
        .then(function (res) {

          const project = res.toJSON().project;
          errorMessageService.showSuccess($scope.labels.getLabel('projectadded'));
          ProjectDataservice.setProjectById(project._id, project);
          $scope.building = {};

          if ($scope.buildingForm && $scope.buildingForm.ref.$setPristine) {
            $scope.buildingForm.ref.$setPristine();
            $scope.buildingForm.ref.$setUntouched();
          }
          $state.go('project/overview', {project_id: project._id});
        });
    };

    function addBuilding ({ project }) {
      const newBuilding = {
        _id: project._id,
        versionId: project.versionId,
        newBuilding: {
          name: $scope.building.name,
          templateId: $scope.building.buildingTemplate._id,
          qualityLevel: $scope.building.qualityLevel.value,
        }
      };

      return ProjectAPI.addBuilding(newBuilding).$promise;
    }

    /**
     * Data (modifications) for step 1
     * */
    $scope.cardData = [{
      value: 'template',
      label: Labels.getLabel('projectfromtemplate'),
      content: Help.getHelpText('projecttemplateexplained').languages[Auth.getCurrentUserLanguage()],
      icon: 'library_add',
      datatestid: 'projectfromtemplate'
    }];

    // Only when the user is managing another Project should we display the copy option.
    if (angular.isDefined(userManagedProjects) && userManagedProjects.length !== 0) {
      $scope.cardData.push({
        value: 'copy',
        label: Labels.getLabel('projectcopy'),
        content: Help.getHelpText('projectcopyexplained').languages[Auth.getCurrentUserLanguage()],
        icon: 'content_copy',
        datatestid: 'projectcopy'
      });
    }

    $scope.changeStartingPoint = (value) => {
      if (!stepper.originalSteps) {
        stepper.originalSteps = [...stepper.steps];
      }

      if (value === 'copy') {
        stepper.steps = stepper.steps.slice(0, 3);
        setCopy();
      } else {
        stepper.steps = [...stepper.originalSteps];
        setTemplate();
      }
    };

    function setCopy () {
      $scope.projectFieldsObj.sourceProject = {
        fieldType: 'dropdown',
        label: $scope.labels.getLabel('projectsource'),
        nonAlphabetical: false,
        helpKey: 'projectsource',
        required: true,
        options: userManagedProjects,
        filter: sgAutocompleteHelpers.filter,
        optionsMapping: {
          displayNameKey: 'name',
          valueKey: '_id'
        }
      };

      $scope.projectFieldsObj.copySourceValues = {
        fieldType: 'checkbox',
        label: $scope.labels.getPlural('projectsourcecopyvalue'),
        helpKey: 'projectsourcecopyvalue'
      };
    }

    function setTemplate () {
      delete $scope.project.sourceProject;
      delete $scope.projectFieldsObj.sourceProject;
      delete $scope.projectFieldsObj.copySourceValues;
    }

    /**
     * Data for step 2
     * */
    $scope.project = {};
    $scope.projectFieldsObj = {
      name: {
        fieldType: 'input',
        helpKey: 'name',
        label: $scope.labels.getLabel('projectname'),
        required: true,
        datatestid: 'projectname',
      },
      key: {
        fieldType: 'input',
        helpKey: 'korte_naam',
        label: $scope.labels.getLabel('shortprojectname'),
        required: true,
        datatestid: 'shortprojectname',
        attributes: {
          'ng-minlength': 3,
          'ng-pattern': '/^([a-zA-Z]){1}([a-zA-Z 0-9]*)$/',
          'ng-maxlength': 8,
        },
        validationErrors: {
          pattern: $scope.labels.getLabel('shortprojectnamepatternmessage'),
          minlength: $scope.labels.getLabel('shortprojectnamelengthmessage'),
          maxlength: $scope.labels.getLabel('shortprojectnamelengthmessage'),
        }
      },
      number: {
        fieldType: 'input',
        helpKey: 'projectnummer',
        label: $scope.labels.getLabel('projectnumber'),
        required: true,
        datatestid: 'projectnumber',
      },
      clientName: {
        fieldType: 'input',
        helpKey: 'opdrachtgever',
        label: $scope.labels.getLabel('client'),
        required: true,
        datatestid: 'client',
      }
    };

    const prevButton = {
      label: $scope.labels.getLabel('previous'),
    };

    const nextButton = {
      label: $scope.labels.getLabel('next'),
      validateForm: true,
      datatestid: "next-to-button",
    };

    $scope.projectButtons = [prevButton, nextButton];
    $scope.onlyNextButton = [nextButton];


    $scope.stepCb = function (index) {
      index ? $scope.next() : $scope.prev();
    };

    /**
     * Data for step 3
     * */
    $scope.project.users = [];
    $scope.validateProjectUsers = function () {
      const projUsers = $scope.project.users;
      const cUser = Auth.getCurrentUser();
      return users.length === 0 || isNotManager(projUsers, cUser);
    };

    const isNotManager = (projUsers, cUser) => {
      const cProjectUser = projUsers.find((user) => user.userId._id === cUser._id);
      if (!cProjectUser) {
        return true;
      }

      return cProjectUser.projectRole !== 'manager';
    };

    $scope.projectUsersNext = () => {
      if ($scope.model.startingPoint !== 'copy') {
        $scope.next();
      } else {
        $scope.project.startProjectId = $scope.project.sourceProject._id;
        $scope.createProjectAndBuilding(true, false);
      }
    };
    /**
     * Data for step 4
     * */
    $scope.templates = pveTemplates;
    $scope.pveTemplateFieldsObj = {
      pveTemplate: {
        fieldType: 'dropdown',
        label: $scope.labels.getLabel('template'),
        options: pveTemplates,
        optionsMapping: {
          displayNameKey: 'name'
        },
        datatestid: 'project-template',
        required: true,
        filter: sgAutocompleteHelpers.filter,
        searchTextChanged: false,
        nonAlphabetical: false
      },
      qualityLevel: {
        fieldType: 'dropdown',
        label: $scope.labels.getLabel('qualitylevel'),
        options: $scope.qualityLevels,
        optionsMapping: {
          displayNameKey: 'displayName',
          valueKey: 'value',
        },
        datatestid: 'project-quality-level',
        required: true,
        filter: sgAutocompleteHelpers.filter,
        searchTextChanged: false,
        nonAlphabetical: true,
        onChange: (obj) => {
          $scope.building.qualityLevel = obj.item;
        }
      }
    };
    $scope.pveTemplateInfoObj = {
      title: $scope.labels.getLabel('projecttemplateinformation'),
      targetObjKey: 'pveTemplate',
      targetObjInfoKey: 'info'
    };

    /**
     * Data for step 5
     * */
    $scope.building = {};
    $scope.buildingAddData = buildingAddData;
    $scope.buildingTemplates = buildingTemplates;
    $scope.buildingAddData.fieldsObj.searchValue = '';
    $scope.buildingAddData.fieldsObj.buildingTemplate.options = buildingTemplates;
    $scope.buildingAddData.fieldsObj.qualityLevel.options = $scope.qualityLevels;
    $scope.buildingAddData.fieldsObj.buildingTemplate.onChange = (obj) => {
      $scope.buildingAddData.infoObj.chips = {
        label: $scope.labels.getPluralCapFirstLetter('linkedareatemplate'),
        items: obj.value,
        itemLabelKey: 'name'
      };
    };

    if ($scope.buildingAddData.buttons.length === 1) {
      $scope.buildingAddData.buttons.unshift(prevButton);
    }
  }

})();
